import React,{ useState, useEffect } from 'react';
import { Button} from '../kit-components/Button';
import {Input} from '../kit-components/Input'
import {Phone} from '../kit-components/Phone'
import styles from './info-step.module.scss';


export default function InfoStep(props) {
  const { loading, handleInfoSubmit } = props;
  const [data, setData] = useState({
    phone: '',
    pinCode: '',
  });
  const [appLink, setAppLink] =  useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const getMobileOperatingSystem = ()=> {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }
    return "unknown";
}

  useEffect(()=>{
    if(getMobileOperatingSystem() ==="iOS"){
      setAppLink("https://apps.apple.com/eg/app/souhoola-%D8%B3%D9%87%D9%88%D9%84%D8%A9/id1514405177");
    }
    else{
      setAppLink("https://play.google.com/store/apps/details?id=com.cicapital.cicf.android.myapplication&pli=1");
    }
  },[]);

  const handleChange = (e) => {
    setData((_data) => ({ ..._data, [e.target.name]: e.target.value }));
  };
  const handlePhoneChange = (phoneNumber)=>{
    setData({...data,phone:phoneNumber});
  }
  const handlePinChange=(e)=>{
    setData({...data, pinCode:e.target.value});
  }
  const handleSubmit = async() => {
   const res = await handleInfoSubmit(data);
   if( res && res.status === 400){
    setErrorMessage(res.data.message);
   }
  };
  return (
    <div className={styles['form']}>
      {errorMessage && (
        <p className={styles['error-message']}>{errorMessage}</p>
      )} 

      <Phone name={'phone'} value={data.phone} onChange={handlePhoneChange} />
      <Input
        name={'pinCode'}
        placeholder={'••••••••••'}
        label={'Souhoola pin code'}
        type="password"
        value={data.pinCode}
        onChange={handlePinChange}
      />
      <div className={styles['receive-code']}>
        Don’t have a Souhoola Account?
        <a href={appLink}>Download app & Sign up now</a>
      </div>

      <div className={styles['actions']}>
        <Button
          disabled={!(data.phone && data.pinCode)}
          loading={loading}
          label="continue"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
